/***
 *
 *   AUTH LAYOUT
 *   Layout for the signup/signin pages
 *
 **********/

import { Helmet } from 'react-helmet';

export function AuthLayout(props) {
  const isWhiteLabelledDomain =
    !window.location.href.includes('salesblink') &&
    !window.location.href.includes('localhost');

  return (
    <>
      {isWhiteLabelledDomain && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      {<props.children {...props.data} />}
    </>
  );
}
